<template>
  <div class="trx-body">
    <div class="header-title">Transaction</div>

    <b-card no-body id="content">
      <b-tabs card>
        <b-tab active title-link-class="tab">
          <template v-slot:title>
            <svg xmlns="http://www.w3.org/2000/svg" width="22.998" height="23" viewBox="0 0 33.998 34">
              <g id="Group-18" transform="translate(-727.35 -294.35)">
                <path id="Path_103" data-name="Path 103" d="M756.4,328.35H732.3a4.955,4.955,0,0,1-4.949-4.949V299.3a4.955,4.955,0,0,1,4.949-4.949h17.675a4.956,4.956,0,0,1,4.947,4.949v24.1a1.481,1.481,0,0,0,1.479,1.479,1.735,1.735,0,1,1,0,3.471Zm-24.1-30.53a1.481,1.481,0,0,0-1.479,1.479v24.1a1.481,1.481,0,0,0,1.479,1.479h19.377a4.934,4.934,0,0,1-.226-1.479V299.3a1.481,1.481,0,0,0-1.478-1.479Z" fill="#707070"/>
                <path id="Path_104" data-name="Path 104" d="M1063.55,553.6a4.955,4.955,0,0,1-4.95-4.949V539.01a1.735,1.735,0,0,1,1.735-1.735h3.214a4.956,4.956,0,0,1,4.948,4.949v6.426A4.956,4.956,0,0,1,1063.55,553.6Zm-1.48-12.855v7.905a1.478,1.478,0,1,0,2.956,0v-6.426a1.481,1.481,0,0,0-1.478-1.479Z" transform="translate(-307.149 -225.25)" fill="#707070"/>
                <path id="Path_105" data-name="Path 105" d="M828.657,507.621H817.41a1.735,1.735,0,0,1,0-3.471h11.247a1.735,1.735,0,0,1,0,3.471Z" transform="translate(-81.899 -194.535)" fill="#707070"/>
                <path id="Path_106" data-name="Path 106" d="M823.837,595.945H817.41a1.735,1.735,0,0,1,0-3.47h6.426a1.735,1.735,0,0,1,0,3.47Z" transform="translate(-81.899 -276.434)" fill="#707070"/>
                <path id="Path_107" data-name="Path 107" d="M828.657,419.3H817.41a1.735,1.735,0,0,1,0-3.47h11.247a1.735,1.735,0,0,1,0,3.47Z" transform="translate(-81.899 -112.638)" fill="#707070" />
              </g>
            </svg>

            <span class="tab-title">History</span>
          </template>

          <div>
            <div class="trx-btn-container">
              <div class="trx-inner-container">
                <button :class="switch_tab == 1 ? 'trx-btn trx-btn_active' : 'trx-btn'" @click="switch_tab = 1">
                  <img :src="require('../assets/icon/send.svg')" />

                  <div class="pl-4 mt-1">Receive</div>
                </button>

                <button :class="switch_tab == 2 ? 'trx-btn trx-btn_active ml-3' : 'trx-btn ml-3'" @click="switch_tab = 2">
                  <img :src="require('../assets/icon/receive.svg')" />
                  <div class="pl-4 mt-1">Send</div>
                </button>
              </div>

              <!-- <div>
                <button class="btn-export ml-3">
                  <img :src="require('../assets/icon/export.svg')" />

                  <span class="pl-2">Export</span>
                </button>
              </div> -->
            </div>

            <div class="d-flex justify-content-center align-items-center h-100 mt-4 spinning" v-if="isLoading">
              <b-spinner variant="success" label="Spinning"></b-spinner>
            </div>

            <!-- Deposit -->
            <div class="trx-table" v-if="switch_tab === 1 && !isLoading">
              <div class="d-flex flex-wrap">
                <div class="col-lg-3 col-12 mb-3">
                  <button @click="updateTransaction" class="btn activate-btn w-75 p-1">{{refreshStatus}}</button>
                </div>
                <div class="col-lg-9 col-12 px-0">
                  <form class="row mx-0" @submit.stop.prevent="rescan">
                    <div class="col-6 px-1">
                      <input type="number" step="0" min="1" class="form-control" placeholder="Block number" v-model="blockNumber" required>
                    </div>

                    <div class="col-6 d-flex px-1">
                      <select v-model="selectedNetwork" class="custom-select mx-2" required>
                        <option v-for="network in networks" :key="`deposit${network.value}`" :value="network.value">{{network.text}}</option>
                      </select>
                      <button class="btn activate-btn p-1">Rescan</button>
                    </div>
                  </form>
                </div>
              </div>
              <b-table
                tbody-tr-class="rowClass"
                :items="deposit_balance"
                :per-page="perPage"
                :current-page="currentPage"
                :fields="depositFields"
                show-empty
                small
                responsive
                detailed
                empty-filtered-text="No Data"
                class="trx-table"
                id="deposit-table"
                @row-clicked="handleRowClicked"
              >
                <!-- start table header -->
                <template v-slot:head(hash)>
                  <div class="table-header-content">
                    <div>TX/ID</div>
                    <div>
                      <input type="text" class="txID-input" placeholder="Enter TX/ID"/>
                    </div>
                  </div>
                </template>

                <template v-slot:head(token)>
                  <div class="table-header-content">
                    <div>COIN</div>
                    <div>
                      <select v-model="coinDepositSelected" @change="changeDepositSelectedSymbol" id="coinSortList" class="tx-dropdown">
                        <option v-for="coinOption in coinOptions" :value="coinOption" :key="coinOption.id">
                          {{ coinOption.api_symbol }}
                        </option>
                      </select>
                    </div>
                  </div>
                </template>

                <template v-slot:head(amount)>
                  <div class="table-header-content">
                    <div>({{coinDepositSelected?.symbol}}) <br> AMOUNT</div>
                    <div>
                      <input type="text" class="txID-readonly" :placeholder="`Total: ${formatNum(totalDepositAmount, deposit_volume_decimal)}`" readonly="readonly"/>
                    </div>
                  </div>
                </template>

                <!-- deposit network fee not important -->
                <!-- <template v-slot:head(actual_gas)>
                  <div class="table-header-content">
                    <div>({{coinDepositSelected?.network?.symbol}}) <br> NETWORK FEE</div>
                    <div>
                      <input type="text" class="txID-readonly" :placeholder="`Total: ${totalDepositNetworkFee}`" readonly="readonly"/>
                    </div>
                  </div>
                </template> -->

                <template v-slot:head(service_fee)>
                  <div class="table-header-content">
                    <div>({{coinDepositSelected?.symbol}}) <br> CHARGE FEE</div>
                    <div>
                      <input type="text" class="txID-readonly" :placeholder="`Total: ${formatNum(totalDepositChargeFee, deposit_volume_decimal + 2)}`" readonly="readonly"/>
                    </div>
                  </div>
                </template>

                <template v-slot:head(timestamp)>
                  <div class="table-header-content">
                    <div>DATE/TIME</div>
                    <div class="d-flex flex-column">
                      <input v-model="depositStartDate" placeholder="Start" class="txID-input mr-1 mb-1" type="text" onfocus="(this.type='date')" onblur="(this.type='text')"  />
                      <input v-model="depositEndDate" placeholder="End" class="txID-input" type="text" onfocus="(this.type='date')" onblur="(this.type='text')" :min="depositStartDate" />
                    </div>
                    <!-- <date-range-picker
                        ref="picker"
                        v-model="depositDateRange"
                    >
                        <template v-slot:input="picker">
                            {{ picker.startDate | date }} - {{ picker.endDate | date }}
                        </template>
                    </date-range-picker> -->
                  </div>
                </template>

                <template v-slot:head(status)>
                  <div class="table-header-content">
                    <div>STATUS</div>
                    <div>
                      <select
                        v-model="selectedDepositStatus"
                        id="coinList"
                        class="tx-dropdown"
                      >
                        <option v-for="status in depositStatus" :value="status.value" :key="`deposit${status.value}`">
                          {{ status.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </template>

                <template v-slot:head(action)>
                  <div class="table-header-content">
                    <div>ACTION</div>
                  </div>
                </template>
                <!-- end table header -->

                <!-- start table body -->
                <template #cell(hash)="row">
                  <div class="trxID-td" v-if="row.item.hash == null || row.item.hash == ''">—</div>
                    <div class="trxID-td" v-else>
                      {{ txIDFormatter(row.item.hash) }}
                      <b-icon-box-arrow-up-right class="ml-2" type="button" @click.stop.prevent="toExplorer(coinDepositSelected.network.symbol.toLowerCase(),row.item.hash)"></b-icon-box-arrow-up-right>
                    </div>
                </template>
                <template #cell(token)="row">
                  {{ row.item.token.api_symbol }}
                </template>
                <template #cell(amount)="row">
                  {{ formatNum(row.item.amount, deposit_volume_decimal) }}
                </template>
                <!-- <template #cell(actual_gas)="row">
                  {{ addCommas(row.item.actual_gas) }}
                </template> -->
                <template #cell(service_fee)="row">
                  {{ row.item.service_fee == 0 ? 'nil' :
                  formatNum(row.item.service_fee, withdraw_volume_decimal + 2) == 0 ? "&lt;" + (1 / 10 ** (withdraw_volume_decimal + 2))  : 
                  formatNum(row.item.service_fee, withdraw_volume_decimal + 2) }}
                </template>
                <template #cell(timestamp)="row">
                  {{ timestampFormatter(row.item.created_at) }}
                </template>
                <template #cell(status)="row">
                  <span
                    class="table_status" 
                      :style="
                        (row.item.status == 'success') ? 'color: var(--primary)' :
                        (row.item.status == 'fail') ? 'color: var(--danger)' :
                        'color: var(--info)'
                    "
                  >
                    {{ row.item.status }}
                  </span>
                </template>
                <!-- <template #cell(action)="row">
                  <button class="btn activate-btn" @click.stop.prevent="resendNotification(row.item.id)">Resend</button>
                </template> -->
                <template #empty="scope">
                  <p class="text-center">{{ (scope.emptyText = "No Data") }}</p>
                </template>
                <!-- end table body -->

                <!-- start expanded body -->
                <template slot="row-details" slot-scope="row">
                  <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">TX ID</div>

                      <div class="expand-right">
                        <div class="mr-3 trxID-td">{{ row.item.hash == null || row.item.hash == '' ? "—" : row.item.hash }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.hash == null || row.item.hash == '')">
                          <b-icon-box-arrow-up-right class="mx-2" type="button" @click.stop.prevent="toExplorer(coinDepositSelected.network.symbol.toLowerCase(),row.item.hash)"></b-icon-box-arrow-up-right>
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.hash, `hash` + row.item.id)">
                            <b-icon-box-arrow-up-right class="mx-2" type="button" @click.stop.prevent="toExplorer(coinDepositSelected.network.symbol.toLowerCase(),row.item.hash)"></b-icon-box-arrow-up-right>
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'hash' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">Deposit ID</div>

                      <div class="expand-right">
                        <div class="mr-3">{{ row.item.deposit_id == null || row.item.deposit_id == '' ? "—" : row.item.deposit_id }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.deposit_id == null || row.item.deposit_id == '')">
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.deposit_id, `deposit_id` + row.item.id)">
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'deposit_id' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">From Address</div>

                      <div class="expand-right">
                        <div class="mr-3">{{ row.item.from == null || row.item.from == '' ? "—" : row.item.from }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.from == null || row.item.from == '')">
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.from, `from_address` + row.item.id)">
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'from_address' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">To Address</div>

                      <div class="expand-right">
                        <div class="mr-3">{{ row.item.to == null || row.item.to == '' ? "—" : row.item.to }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.to == null || row.item.to == '')">
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.to, `to_address` + row.item.id)">
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'to_address' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">Remarks</div>

                      <div class="expand-right">
                        <div class="mr-3">{{ row.item.remarks == null || row.item.remarks == '' ? "—" : row.item.remarks }}</div>

                        <div class="tooltip__layout">
                          <button class="icon-btn pl-2" @click="showEditRemarksModal(row.item, 'deposits')">
                            <inline-svg
                              :src="require('../assets/icon/edit.svg')"
                              width="18"
                              aria-label="edit"
                            ></inline-svg>
                            <!-- <span class="tooltip__content" :id="'remarks' + row.item.id">Copied!</span> -->
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </template>
                <!-- end expanded body -->
              </b-table>

              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="10"
                aria-controls="deposit-table"
                align="center"
              ></b-pagination>
            </div>

            <!-- Withdrawal -->
            <div class="trx-table" v-if="switch_tab === 2 && !isLoading">
              <div class="d-flex flex-wrap">
                <div class="col-lg-3 col-12 mb-3">
                  <button @click="updateTransaction" class="btn activate-btn w-75 p-1">{{refreshStatus}}</button>
                </div>
                <div class="col-lg-9 col-12 px-0">
                  <form class="row mx-0" @submit.stop.prevent="rescan">
                    <div class="col-6 px-1">
                      <input type="number" step="0" min="1" class="form-control" placeholder="Block number" v-model="blockNumber" required>
                    </div>

                    <div class="col-6 d-flex px-1">
                      <select v-model="selectedNetwork" class="custom-select mx-2" required>
                        <option v-for="network in networks" :key="`deposit${network.value}`" :value="network.value">{{network.text}}</option>
                      </select>
                      <button class="btn activate-btn p-1">Rescan</button>
                    </div>
                  </form>
                </div>
              </div>

              <b-table
                tbody-tr-class="rowClass"
                :items="withdrawal_balance"
                :per-page="perWithdraw"
                :current-page="currentWithdraw"
                :fields="withdrawFields"
                show-empty
                small
                responsive
                empty-filtered-text="No Data"
                class="trx-table"
                id="withdraw-table"
                @row-clicked="handleRowClicked"
              >
                <!-- start table header -->
                <template v-slot:head(hash)>
                  <div class="table-header-content">
                    <div>TX/ID</div>
                    <div>
                      <input type="text" class="txID-input" placeholder="Enter TX/ID"/>
                    </div>
                  </div>
                </template>

                <template v-slot:head(token)>
                  <div class="table-header-content">
                    <div>COIN</div>
                    <div>
                      <select v-model="coinWithdrawSelected" @change="changeWithdrawSelectedSymbol" id="coinSortList" class="tx-dropdown">
                        <option v-for="coinOption in coinOptions" :value="coinOption" :key="coinOption.id">
                          {{ coinOption.api_symbol }}
                        </option>
                      </select>
                    </div>
                  </div>
                </template>

                <template v-slot:head(amount)>
                  <div class="table-header-content">
                    <div>({{coinWithdrawSelected?.symbol}}) <br> AMOUNT</div>
                    <div>
                      <input type="text" class="txID-readonly" :placeholder="`Total: ${formatNum(totalWithdrawAmount, withdraw_volume_decimal)}`" readonly="readonly"/>
                    </div>
                  </div>
                </template>

                <template v-slot:head(actual_gas)>
                  <div class="table-header-content">
                    <div>({{coinWithdrawSelected?.network?.symbol}}) <br> NETWORK FEE</div>
                    <div>
                      <input type="text" class="txID-readonly" :placeholder="`Total: ${totalWithdrawNetworkFee}`" readonly="readonly"/>
                    </div>
                  </div>
                </template>

                <template v-slot:head(service_fee)>
                  <div class="table-header-content">
                    <div>({{coinWithdrawSelected?.symbol}}) <br> CHARGE FEE</div>
                    <div>
                      <input type="text" class="txID-readonly" :placeholder="`Total: ${formatNum(totalWithdrawChargeFee, withdraw_volume_decimal + 2)}`" readonly="readonly"/>
                    </div>
                  </div>
                </template>

                <template v-slot:head(created_at)>
                  <div class="table-header-content">
                    <div>DATE/TIME</div>
                    <div class="d-flex flex-column">
                      <input v-model="withdrawStartDate" placeholder="Start" class="txID-input mr-1 mb-1" type="text" onfocus="(this.type='date')" onblur="(this.type='text')"  />
                      <input v-model="withdrawEndDate" placeholder="End" class="txID-input" type="text" onfocus="(this.type='date')" onblur="(this.type='text')" :min="withdrawStartDate" />
                    </div>
                    <!-- <div>
                      <select v-model="dateTime_sort_selected" id="dateTimeSortList" class="tx-dropdown">
                        <option v-for="sort in dateTime_sort" :key="sort.sortID">
                          {{ sort.sortName }}
                        </option>
                      </select>
                    </div> -->
                  </div>
                </template>

                <template v-slot:head(status)>
                  <div class="table-header-content">
                    <div>STATUS</div>
                    <div>
                      <select
                        v-model="selectedWithdrawStatus"
                        id="coinList"
                        class="tx-dropdown"
                      >
                        <option v-for="status in withdrawStatus" :value="status.value" :key="`withdraw${status.value}`">
                          {{ status.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </template>

                <template v-slot:head(action)>
                  <div class="table-header-content">
                    <div>ACTION</div>
                  </div>
                </template>
                <!-- end table header -->

                <!-- start table body -->
                <template #cell(hash)="row">
                  <div class="trxID-td" v-if="row.item.hash == null || row.item.hash == ''">—</div>
                    <div class="trxID-td" v-else>
                      {{ txIDFormatter(row.item.hash) }}
                      <b-icon-box-arrow-up-right class="ml-2" type="button" @click.stop.prevent="toExplorer(coinWithdrawSelected.network.symbol.toLowerCase(),row.item.hash)"></b-icon-box-arrow-up-right>
                    </div>
                </template>
                <template #cell(token)="row">
                  {{ row.item.token.api_symbol }}
                </template>
                <template #cell(amount)="row">
                  {{ formatNum(row.item.amount, withdraw_volume_decimal)}}
                </template>
                <template #cell(actual_gas)="row">
                  {{ addCommas(row.item.actual_gas) }}
                </template>
                <template #cell(service_fee)="row">
                  {{ row.item.service_fee == 0 ? 'nil' :
                  formatNum(row.item.service_fee, withdraw_volume_decimal + 2) == 0 ? "&lt;" + (1 / 10 ** (withdraw_volume_decimal + 2))  : 
                  formatNum(row.item.service_fee, withdraw_volume_decimal + 2) }}
                </template>
                <template #cell(created_at)="row">
                  {{ dateFormatter(row.item.created_at) }}
                </template>
                <template #cell(status)="row">
                  <span
                    class="table_status" 
                      :style="
                        (row.item.status == 'success') ? 'color: var(--primary)' :
                        (row.item.status == 'fail') ? 'color: var(--danger)' :
                        'color: var(--info)'
                    "
                  >
                    {{ row.item.status }}
                  </span>
                </template>
                <!-- <template #cell(action)="row">
                  <button class="btn activate-btn" @click.stop.prevent="resendNotification(row.item.id)">Resend</button>
                </template> -->

                <template #empty="scope">
                  <p class="text-center">{{ (scope.emptyText = "No Data") }}</p>
                </template>
                <!-- end table body -->

                <!-- start expanded body -->
                <template slot="row-details" slot-scope="row">
                  <div class="d-flex flex-column w-100">
                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">TX ID</div>

                      <div class="expand-right">
                        <div class="mr-3 trxID-td">{{ row.item.hash == null || row.item.hash == '' ? "—" : row.item.hash }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.hash == null || row.item.hash == '')">
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.hash, `hash` + row.item.id)">
                            <b-icon-box-arrow-up-right class="mx-2" type="button" @click.stop.prevent="toExplorer(coinWithdrawSelected.network.symbol.toLowerCase(),row.item.hash)"></b-icon-box-arrow-up-right>
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'hash' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">Request ID</div>

                      <div class="expand-right">
                        <div class="mr-3">{{ row.item.request_id == null || row.item.request_id == '' ? "—" : row.item.request_id }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.request_id == null || row.item.request_id == '')">
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.request_id, `request_id` + row.item.id)">
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'request_id' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">From Address</div>

                      <div class="expand-right">
                        <div class="mr-3">{{ row.item.from == null || row.item.from == '' ? "—" : row.item.from }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.from == null || row.item.from  == '')">
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.from, `from_address` + row.item.id)">
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'from_address' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">To Address</div>

                      <div class="d-flex flex-row expand-right">
                        <div class="mr-3">{{ row.item.to == null || row.item.to == '' ? "—" : row.item.to }}</div>

                        <div class="tooltip__layout" v-if="!(row.item.to == null || row.item.to == '')">
                          <button class="icon-btn pl-2" @click="copyToClip(row.item.to, `to_address` + row.item.id)">
                            <inline-svg
                                :src="require('../assets/icon/copy.svg')"
                                width="18"
                                aria-label="copy"
                            ></inline-svg>
                            <span class="tooltip__content" :id="'to_address' + row.item.id">Copied!</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row w-100">
                      <div class="expand-left">Remarks</div>

                      <div class="expand-right">
                        <div class="mr-3">{{ row.item.remarks == null || row.item.remarks == '' ? "—" : row.item.remarks }}</div>

                        <div class="tooltip__layout">
                          <button class="icon-btn pl-2" @click="showEditRemarksModal(row.item, 'withdrawals')">
                            <inline-svg
                              :src="require('../assets/icon/edit.svg')"
                              width="18"
                              aria-label="edit"
                            ></inline-svg>
                            <!-- <span class="tooltip__content" :id="'remarks' + row.item.id">Copied!</span> -->
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </template>
                <!-- end expanded body -->
              </b-table>

              <b-pagination
                v-model="currentWithdraw"
                :total-rows="totalWithdraw"
                :per-page="10"
                aria-controls="withdraw-table"
                align="center"
              ></b-pagination>
            </div>
          </div>
        </b-tab>

        <b-modal ref="edit-remark-modal" hide-footer title="Edit Remark" centered>
          <div class="d-flex flex-column text-center">
            <div class="form-group d-flex justify-content-center">
              Edit remarks for this {{ editRemarksForm.type }}:-
            </div>
            <div class="form-group d-flex  mr-5">
              <label class="mr-2">Hash: </label>
              <input type="text" class="reject-input" :value="editRemarksForm.hash" disabled>
            </div>

            <!-- <div class="form-group d-flex  mr-5">
              <label class="mr-2">Email: </label>
              <input type="text" class="reject-input" :value="editRemarksForm.email" disabled>
            </div> -->

            <div class="form-group d-flex">
              <label class="mr-2">Remarks: </label>
              <textarea name="" id="" cols="28" rows="3" v-model="editRemarksForm.remarks"></textarea>
            </div>

            <div class="form-group">
              <div class="mt-3 mb-1 w-100">
                <button type="primary" class="btn submit-btn" name="sendEditRemark" @click="sendEditRemarksForm()">
                  Edit Remarks</button>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- <b-tab>
          <template v-slot:title>
            <svg xmlns="http://www.w3.org/2000/svg" width="19.441" height="22.488" viewBox="0 0 38.441 41.488">
              <g id="Group_432" data-name="Group 432" transform="translate(-27 -9.325)">
                <g id="Group_429" data-name="Group 429" transform="translate(27 9.325)">
                  <path id="Path_102" data-name="Path 102" d="M47.1,45.291a2.209,2.209,0,0,0-2.057-2.237l-.025,0a17.251,17.251,0,0,1-1.727-.247A14.578,14.578,0,1,1,60.517,31.428c-.048.233-.1.463-.162.694a14.568,14.568,0,0,1-.975,2.691,2.265,2.265,0,0,0,1.9,3.286l.119.005a2.264,2.264,0,0,0,2.141-1.272,19.132,19.132,0,0,0,1.51-4.481l.006-.029a19.226,19.226,0,1,0-37.763-7.243c-1.8,9.859,4.956,18.591,12.3,21.473a17.136,17.136,0,0,0,5.143,1.135A2.218,2.218,0,0,0,47.1,45.52Z" transform="translate(-27 -9.325)" fill="#707070"/>
                </g>
                <g id="Group_430" data-name="Group 430" transform="translate(38.088 15.883)">
                  <rect id="Rectangle_172" data-name="Rectangle 172" width="4.012" height="16.289" rx="2.006" transform="translate(10.556 16.289) rotate(-180)" fill="#707070"/>
                  <rect id="Rectangle_173" data-name="Rectangle 173" width="4.012" height="12.092" rx="2.006" transform="translate(8.55 11.599) rotate(45)" fill="#707070"/>
                </g>
                <g id="Group_431" data-name="Group 431" transform="translate(51.674 31.517)">
                  <rect id="Rectangle_174" data-name="Rectangle 174" width="3.606" height="14.641" rx="1.803" transform="translate(3.606 14.641) rotate(-180)" fill="#707070"/>
                  <circle id="Ellipse_9" data-name="Ellipse 9" cx="1.826" cy="1.826" r="1.826" transform="translate(0 15.644)" fill="#707070"/>
                </g>
              </g>
            </svg>

            <span class="tab-title">Pending</span>
          </template>

          <b-card-text>Tab contents 2</b-card-text>
        </b-tab> -->
      </b-tabs>
    </b-card>

  </div>
</template>

<script>
import api from '../helper/api.js';
import InlineSvg from "vue-inline-svg";
import moment from 'moment';
import Swal from 'sweetalert2';
import coinHelper from "../helper/coin.js";
import explorer from '../helper/explorer.js';

export default {
  name: 'Transaction',
  components: {
    InlineSvg,
    // DateRangePicker
  },    
  data() {
    return {
      deposit_data: [],
      switch_tab: 1,
      depositFields: [
        { key: "hash", label: "TX/ID" },
        { key: "token", label: "COIN"},
        { key: "amount", label: "AMOUNT" },
        // { key: "actual_gas", label: "NETWORK FEE" },
        { key: "service_fee", label: "CHARGE FEE" },
        { key: "timestamp", label: "DATE/TIME" },
        { key: "status", label: "STATUS" },
        { key: "action", label: "ACTION" },
      ],
      withdrawFields: [
        { key: "hash", label: "TX/ID" },
        { key: "token", label: "COIN"},
        { key: "amount", label: "AMOUNT" },
        { key: "actual_gas", label: "NETWORK FEE" },
        { key: "service_fee", label: "CHARGE FEE" },
        { key: "created_at", label: "DATE/TIME" },
        { key: "status", label: "STATUS" },
        { key: "action", label: "ACTION" },
      ],
      coin_sort: [
        { sortID: 0, sortName: 'All' },
        { sortID: 1, sortName: 'Alphabet A-Z' },
        { sortID: 2, sortName: 'Alphabet Z-A' },
      ],
      coinSort_selected: 'All',
      dateTime_sort: [
        { sortID: 0, sortName: 'All' },
        { sortID: 1, sortName: 'Past 7 Days' },
        { sortID: 2, sortName: 'Past 30 Days' },
        { sortID: 3, sortName: 'Past 90 Days' },
      ],
      dateTime_sort_selected: 'All',
      status_sort: [
        { sortID: 0, sortName: 'All' },
        { sortID: 1, sortName: 'Pending' },
        { sortID: 2, sortName: 'Failed' },
      ],
      status_sort_selected: 'All',
      opened: [],
      isLoading: false,
      deposit_balance: [],
      withdrawal_balance: [],
      deposit_volume_decimal: 0,
      withdraw_volume_decimal: 0,
      currentPage: 1,
      currentWithdraw: 1,
      totalRows: 0,
      totalWithdraw: 0,
      perPage:10,
      perWithdraw: 10,
      allOpenRows: [],
      coinOptions:[],
      coinDepositSelected:null,
      // deposit sum
      totalDepositAmount:0,
      totalDepositNetworkFee:0,
      totalDepositChargeFee:0,
      // withdraw sum
      totalWithdrawAmount:0,
      totalWithdrawNetworkFee:0,
      totalWithdrawChargeFee:0,
      depositStatus:[
        {value:null, text:"All"},
        {value:"pending_gather", text:"Pending Gather"}, 
        {value:"gathering", text:"Gathering"}, 
        {value:"fail_gather", text:"Fail Gather"}, 
        {value:"success", text:"Success"}
      ],
      withdrawStatus:[
        {value:null, text:"All"},
        {value:"pending", text:"Pending"}, 
        {value:"invalid", text:"Invalid"}, 
        {value:"broadcast", text:"Broadcast"}, 
        {value:"broadcasting", text:"Broadcasting"}, 
        {value:"success", text:"Success"}, 
        {value:"fail", text:"Fail"}, 
      ],
      selectedDepositStatus:null,
      selectedWithdrawStatus:null,
      networks:[
        {value:"trx",text:"TRX"},
        {value:"eth",text:"ETH"},
        {value:"bsc",text:"BSC"},
      ],
      selectedNetwork:'trx',
      blockNumber:null,
      depositStartDate:null,
      depositEndDate:null,
      withdrawStartDate:null,
      withdrawEndDate:null,
      refreshStatus:"Update",
      editRemarksForm:{
        id: '',
        type: '',
        hash: '',
        remarks: '',
      }
    }
  },

  watch: {
    currentPage: {
      async handler() {
        this.isLoading = true
        await this.fetchDepositHistory();
      },
      deep: true,
    },

    currentWithdraw: {
      async handler() {
        this.isLoading = true
        await this.fetchWithdrawalHistory();
      },
      deep: true,
    },

    selectedDepositStatus(){
      this.isLoading = true;
      this.fetchDepositHistory();
    },

    selectedWithdrawStatus(){
      this.isLoading = true;
      this.fetchWithdrawalHistory();
    },

    depositStartDate(value){
      if(this.depositEndDate && value != null){
        this.isLoading = true;
        this.fetchDepositHistory();
      }
    },

    depositEndDate(value){
      if(this.depositStartDate && value != null){
        this.isLoading = true;
        this.fetchDepositHistory();
      }
    },  

    withdrawStartDate(value){
      if(this.withdrawEndDate && value != null){
        this.isLoading = true;
        this.fetchWithdrawalHistory();
      }
    },

    withdrawEndDate(value){
      if(this.withdrawStartDate && value != null){
        this.isLoading = true;
        this.fetchWithdrawalHistory();
      }
    }
  },

  async mounted() {
    this.isLoading = true;
    await this.fetchCoins();
    await this.fetchDepositHistory();
    await this.fetchWithdrawalHistory();
  },

  methods: {
    addCommas (nStr) {
      nStr += ''
      var x = nStr.split('.')
      var x1 = x[0]
      var x2 = x.length > 1 ? '.' + x[1] : ''
      var rgx = /(\d+)(\d{3})/
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
      }
      return x1 + x2
    },

    txIDFormatter(address) {
      return address.substring(0, 4) + '...' + address.substring(address.length - 4)
    },

    formatNum(num, decimal){
      return coinHelper.formatNumberWithCommas(num, decimal);
    },  

    timestampFormatter(value) {
      if (value) {
        // value = new Date(value/1000);
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
      }
    },

    dateFormatter(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
      }
    },

    handleRowClicked(item) {
      this.allOpenRows.map((ele) => {
        if (ele.id !== item.id && ele._showDetails) {
          this.$set(ele, "_showDetails", !ele._showDetails);
        }
      });
      this.allOpenRows = [];
      this.$set(item, "_showDetails", !item._showDetails);
      this.allOpenRows.push(item);
    },

    toggle(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened.push(id)
      }
    },

    async fetchCoins(){
      try{
        const response = await api.apiCall('core','GET','/tokens/get-all');
        this.coinOptions = response.message;        
        // this.coinDepositSelected = this.coinOptions.filter((item)=>item.api_symbol == 'TRX')[0];
        // this.coinWithdrawSelected = this.coinOptions.filter((item)=>item.api_symbol == 'TRX')[0];

        this.coinDepositSelected = this.coinOptions[0];
        this.coinWithdrawSelected = this.coinOptions[0];
      }catch(error){
        console.error(error);
      }
    },

    async copyToClip(address, id) {
      event.stopImmediatePropagation();
      await this.$copyText(address).then(function () {
        var x = document.getElementById(id);
        x.classList.add("show");
        setTimeout(function () {
          x.classList.remove("show");
        }, 1000);
      })
    },

    showEditRemarksModal(rowItems, type) {
      this.editRemarksForm.id = rowItems.id;
      this.editRemarksForm.type = type;
      this.editRemarksForm.hash = this.txIDFormatter(rowItems.hash);
      this.editRemarksForm.remarks = rowItems.remarks;
      this.$refs['edit-remark-modal'].show()
    },

    async sendEditRemarksForm() {
      try {
        const params = {
          id: this.editRemarksForm.id,
          remarks: this.editRemarksForm.remarks,
        }
        const endpoint = '/' + this.editRemarksForm.type + '/edit-remark'
        if(this.editRemarksForm.type == 'deposits'){
          await api.apiCall(this.coinDepositSelected.network.symbol.toLowerCase(),'POST', endpoint, params);
        } else {
          await api.apiCall(this.coinWithdrawSelected.network.symbol.toLowerCase(),'POST', endpoint, params);
        }
        this.$refs['edit-remark-modal'].hide()
        Swal.fire({
            text: `Edit remarks ${this.editRemarksForm.hash} success`,
            icon: 'success',
        })
      } catch (error) {
        console.error(error);
      }

    },

    async fetchDepositHistory(){
      try{
        let params = {
          api_symbol:this.coinDepositSelected.api_symbol,
          status:this.selectedDepositStatus,
          // api_symbol:"TRX",
          order : 'DESC',
          page : this.currentPage,
          take: 10,
          start: this.depositStartDate,
          end: this.depositEndDate
        }
        const response = await api.apiCall(this.coinDepositSelected.network.symbol.toLowerCase(),'GET','/deposits',params);
        // const response = await api.apiCall("trx",'GET','/deposits',params);
        this.deposit_balance = response.message.data;
        this.isLoading = false;
        this.totalRows = response.message.meta.itemCount;
        // this.currentPage = response.message.meta.page
        this.perPage = this.deposit_balance - (10* this.currentPage);
        this.totalDepositAmount = response.message.total[0].sum;
        this.totalDepositNetworkFee = response.message.total[0].sum_network;
        this.totalDepositChargeFee = response.message.total[0].sum_charge;
        this.deposit_volume_decimal = response.message.total[0].token_volume_decimal

      }catch(error){
        console.error(error);
      }
    },

    async fetchWithdrawalHistory(){
      try{
        let params = {
          api_symbol:this.coinWithdrawSelected.api_symbol,
          status:this.selectedWithdrawStatus,
          // api_symbol:"TRX",
          order : 'DESC',
          page : this.currentWithdraw,
          take: 10,
          start: this.withdrawStartDate,
          end: this.withdrawEndDate
        }

        const response = await api.apiCall(this.coinWithdrawSelected.network.symbol.toLowerCase(),'GET','/withdrawals',params);
        // const response = await api.apiCall("trx",'GET','/withdrawals',params);
        this.withdrawal_balance = response.message.data;
        this.isLoading = false;
        this.totalWithdraw = response.message.meta.itemCount;
        // this.currentWithdraw = response.message.meta.page
        this.perWithdraw = this.withdrawal_balance - (10* this.currentWithdraw);
        this.totalWithdrawAmount = response.message.total[0].sum;
        this.totalWithdrawNetworkFee = response.message.total[0].sum_network;
        this.totalWithdrawChargeFee = response.message.total[0].sum_charge;
        this.withdraw_volume_decimal = response.message.total[0].token_volume_decimal
        // console.log(response.message.total[0])
      }catch(error){
        console.error(error);
      }
    },

    async rescan(){
      try{
        let params = {
          network:this.selectedNetwork,
          block_number:parseFloat(this.blockNumber)
        }
        await api.apiCall('core','POST','/rescan',params);
        Swal.fire({
            text: `Rescan block ${this.blockNumber} success`,
            icon: 'success',
        })

        this.blockNumber = null;
        this.fetchDepositHistory();
        this.fetchWithdrawalHistory();  
        
      }catch(error){
        console.error(error);
        Swal.fire({
            text: error.message,
            icon: 'error',
        })
      }
    },  

    async resendNotification(id){
      try{
        let params = {
          id : id * 1
        };

        await api.apiCall('core','POST','/notifications/resend',params);
        Swal.fire({
            text: `Resend notification success`,
            icon: 'success',
        })

        // this.blockNumber = null;
        // this.fetchDepositHistory();
        // this.fetchWithdrawalHistory();  

      }catch(error){
        console.error(error);
        Swal.fire({
            text: error.message,
            icon: 'error',
        })
      }
    },

    async updateTransaction(){
      this.refreshStatus = 'Updating...';

      await this.fetchDepositHistory()
      await this.fetchWithdrawalHistory();
      this.refreshStatus = 'Update'
    },  

    changeDepositSelectedSymbol(){
      this.fetchDepositHistory();
      this.isLoading = true;
    },

    changeWithdrawSelectedSymbol(){
      this.fetchWithdrawalHistory();
      this.isLoading = true;
    },

    toExplorer(network,hash){
      let url = explorer.explorerLink(network, 'tx', hash)
      window.open(url, '_blank').focus();
    }
  },
}
</script>

<style>
@import '../css/styles.css';

.trx-body {
  height: 100%;
  overflow: scroll;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.trx-body::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.trx-body {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.trx-btn-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1rem;
  align-items: center;
}

.trx-inner-container {
  display: flex;
  flex-direction: row;
}

.trx-btn {
  background-color: transparent;
  min-width: 100px;
  width: 300px;
  border-radius: 30px;
  border: 2px solid var(--primary);
  color: var(--primary);
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 55px;
}

.trx-btn img {
  width: 30px;
}

.trx-btn:hover {
  color: var(--primary);
  border: 2px solid var(--primary);
  background-color: var(--primary-10);
  box-shadow: rgba(255, 255, 255, 0.2) 0px 2px 8px 0px;
}

.trx-btn_active {
  background-color: var(--primary-10);
}

.btn-export {
  background-color: transparent;
  color: black;
  border: none;
  font-size: 13px;
  display: flex;
  place-items: center;
  place-self: end;
  text-transform: uppercase;
  cursor: pointer;
}

/* table */
.table-responsive {
  display: inline-table;
}

.trx-table {
  font-size: 13px;
  text-align: center;
  margin-top: 2rem;
}

.trx-table th, .trx-table td {
  font-size: 16px;
  border: 1px !important;
}

.trx-table table {
  border-collapse: separate; 
  border-spacing:  0 8px;
}

.trx-table td {
  border-bottom: none;
  padding: 7px 20px;
}

.trx-table tr {
  background-color: var(--light);
}

.b-table-has-details {
  background-color: aliceblue !important;
}

.rowClass:hover {
  cursor: pointer;
  background-color: aliceblue;
}

.b-table-details:hover {
  cursor: auto;
  background-color: white;
}

.expand-left {
  width: 15%;
  padding: 7px 0px;
  text-align: left;
}

.expand-right {
  width: 85%;
  text-align: left;
  padding-left: 4rem;
  display: flex;
  flex-direction: row;
  align-items: center;
}

select {
  text-align-last: center;
}

#trx-table-row {
  background-color: var(--light);
  border-bottom: none;
  border-radius: 20px;
  padding: 7px 20px;
}

.table-header-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table_status {
  text-transform: capitalize;
}

.opened-tr td {
  text-align: left;
}

.opened-tr td:nth-child(2) {
  padding-left: 3rem;
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  /* Firefox 18- */
  text-align: center;
}

::-moz-placeholder {
  /* Firefox 19+ */
  text-align: center;
}

:-ms-input-placeholder {
  text-align: center;
}

.trxID-td {
  color: var(--primary);
  font-style: italic;
  /* width: 300px; */
}

.txID-input {
  background-color: rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 15px;
  min-width: 100px;
  width: 150px;
  color: black;
  text-indent: 10px;
}

.txID-readonly {
  background-color: transparent;
  /* background-color: rgba(0, 0, 0, 0.1); */
  border: none;
  border-radius: 15px;
  min-width: 100px;
  width: 120px;
  color: black;
}

.tx-dropdown {
  border: none;
  color: black;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  height: 23px;
}

.spinning {
  height: 600px !important;
}

.pagination-div {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.pagination-div button {
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  height: 32px;
  width: 32px;
  margin: 0.3rem 5px;
  border: none;
  background-color: white;
}

.pagination-button {
  background-color: var(--primary) !important;
  color: white !important;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%) !important;
}

@media only screen and (max-width: 768px) {
  .trx-btn-container {
    flex-direction: column;
    align-items: end;
  }

  .trx-inner-container {
    width: 100%;
  }

  .btn-export {
    margin-top: 10px;
  }

  .table-responsive {
    display: block;
  }
}
</style>